module.exports = __webpack_public_path__ + "img/LOGO SEPLAG - BRANCO VAZADO.c939980a.svg";